import React from 'react';
import { FaComment, FaWindowClose  } from 'react-icons/fa';
import { peerlessDataForTestimonial } from './PeerlessData';
import Slider from 'react-slick';

const Testimonial = ({setNavLinks, sliderState12, setSliderState12, handleAfterChange12}) => {


          
        React.useEffect(() => {
      // retrieve slider state from local storage on component mount
        const storedState = JSON.parse(sessionStorage.getItem('sliderState12'));
        if(storedState){setSliderState12(storedState)}
   
        }, [setSliderState12]);
        const settings = {
    
            dots: false,
            infinity: true,
            slidesToShow:1,
            slidesToScroll: 1,
            lazyLoad: true,
            Speed: 200,
            swipe: true,
            swipeToSlide: true,
        
       
        }
    
  return (

        <div className='container-fluid'> 

            <div className='close-window-icon' ><FaWindowClose color='#1b2328' onClick={()=>{
              
              setNavLinks({homeLink: true})
              sessionStorage.setItem("currentSession", JSON.stringify({homeLink: true}));
              }}/> </div>
              <h1 className='title'><FaComment color='#1b2328' /> Testimonials </h1>

            
          <div className="testmonial-container">

            <Slider {...settings} afterChange={handleAfterChange12} initialSlide={sliderState12.currentSlide}>

            {

              peerlessDataForTestimonial.map((testimonial)=>{

                return(
                    <article className="testimonialImage" key={testimonial.image}>
                       <img  src = {require(`../Images/Testimonials/${testimonial.image}`)} alt=""/>
                    </article>
                )
              })
            }

            </Slider>
        </div>


           
        </div>

  )
}

export default Testimonial;